import { FilterValue } from "@/shared/types/type/search"

export const getTreatmentCategoryName = (
  treatmentCategoryIds: number[],
  treatmentList: FilterValue[],
) => {
  const matchedId = treatmentCategoryIds.find((id) =>
    treatmentList.some((treatment) => treatment.id === id),
  )
  if (!matchedId) return undefined
  return treatmentList.find((treatment) => treatment.id === matchedId)?.name
}
